import React from 'react'

function BootstrapTables() {
  return (
    <div>
      
    </div>
  )
}

export default BootstrapTables
